import request from '../../utils/request';
import options from './options';

const url = options.apiUrl;
const urlPath = path => `${url}${path}`;

export const getNormative = id => request.get({
    url: urlPath(id),
    id
});

export const getNormatives = () => request.get({
    url
});

export const addNormative = body => request.post({
    url: urlPath('create_calculation/'),
    body: body
});

export const updateNormative = body => request.patch({
    url: urlPath(`${body.id}/update_calculation/`),
    body: body.values
});
